<template>
  <div class="modal__content">
    <h2 class="text-size-13 text-uppercase text-regular text-center mb20">Action required</h2>
    <p class="text-size-18 text-medium text-center mb20">Do you want to add {{args.designer.name}} {{args.designer.surname}} to<br>
     {{args.projectName}} as a designer ?</p>
    <div class="flex flex--justify-center">
      <button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">Cancel</button>
      <button class="btn btn--wide" @click="onConfirm">Confirm</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
    }
  },

  props: {
    args: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions([
      'assigneeDesigner'
    ]),

    async onConfirm () {
      const { projectId, taskId, designer } = this.args
      await this.assigneeDesigner({ projectId, taskId, designer })
      this.$bus.$emit('modalClose')
    }
  }
}
</script>


// WEBPACK FOOTER //
// TaskAssigneeDesignerModal.vue?1924794a